// External Libs
import axios from "axios"

// External files
import { GRAPHQL_API_URL } from "../constants/urls"

export async function fetch(queryString: string): Promise<any> {
  const { data: axiosResponseBody } = await axios({
    method: "POST",
    url: GRAPHQL_API_URL,
    data: JSON.stringify({ query: queryString }),
    headers: { "Content-Type": "application/json" },
  })

  const { data, errors } = axiosResponseBody

  if (errors) {
    throw new Error(`Gobble API returned error: ${errors}`)
  } else {
    return data
  }
}

export async function fetchCampaign(query: string, code?: string): Promise<any> {
  const queryArgument = code ? `(code: "${code}")` : ""
  const queryString = `{ campaign${queryArgument}{ ${query} }}`
  const { campaign } = await fetch(queryString)
  return campaign
}
